var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.toaster)?_c('div',{staticClass:"app-toast",class:_vm.css},[_c('div',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("x")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }